import { create } from 'zustand';

const useStoreCashBook = create((set) => ({
  sortingData: false,
  schedularDate: {},

  setSortingData: (val) => set({ sortingData: val}),
  setSchedularDate: (val) => set({ schedularDate: val }),
}));
export default useStoreCashBook;
